import { ApiService } from '@/services/api'

export const sendVerifyZoom = async () => {
  const response = await ApiService.apiInstance.get<{ isZoom: boolean; inMeeting: boolean }>(
    'auth/verify-zoom-context',
  )

  return response.data
}

export const loadDeeplink = async () => {
  const response = await ApiService.apiInstance.get<{ deeplink: string }>('/auth/deeplink')

  return response.data.deeplink
}
